import _str from "shared/util/_str";

export const PlatformType = {
	DESKTOP: "DESKTOP",
	ANDROID: "ANDROID",
	IOS: "IOS",
	ANDROID_WEB: "ANDROID_WEB",
	MOBILE_WEB: "MOBILE_WEB",
};

export const VoucherStatus = {
	SUCCESS: "SUCCESS",
	FAILURE: "FAILURE",
};

export const CopyText = {
	ALMOST_THERE: _str("You're Almost There!"),
	LETS_GO: _str("Let's Go"),
};

export const VOUCHER_CODE_KEY = "voucherCode";
export const VOUCHER_SET_TIME = "voucherSetTime";
export const DAY_IN_MS = 86400000;



// WEBPACK FOOTER //
// ./src/shared/components/VoucherModal/constants.js